module.exports = __webpack_public_path__ + "static/media/nitp-modified.ae719b0b.png";